import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { STATUSES } from "../../utils/statusObj";
import HttpClient from "../../utils/HttpClient";
import toast from "react-hot-toast";

const initialState = {
    status: STATUSES.IDLE,
    users: [],
    error: null,
};


export const fetchAllUsers = createAsyncThunk('users/fetch/fisibility', async (_, { rejectWithValue }) => {
    try {
        const res = await HttpClient.requestData('alluserlist', 'GET');
        return res;
    } catch (error) {
        return rejectWithValue(error?.message);
    }
});


export const userListSlice = createSlice({
    name: 'fisibility/fetch/users',
    initialState,
    extraReducers: builder => {
        builder.addCase(fetchAllUsers.pending, state => {
            state.status = STATUSES.LOADING;
            state.error = null;
            state.users = [];
        })
            .addCase(fetchAllUsers.fulfilled, (state, { payload }) => {
                if (payload && payload?.status) {
                    state.status = STATUSES.IDLE;
                    state.error = null;
                    state.users = payload?.data?.filter(item => item?.userType === "Bookeeper" || item?.userType === "Personal" || item?.userType === "Business") || [];
                } else {
                    state.status = STATUSES.ERROR;
                    state.error = payload?.message;
                    state.users = [];
                    toast.error(payload?.message || 'Something went wrong!!!');
                }
            })
            .addCase(fetchAllUsers.rejected, (state, { payload }) => {
                state.status = STATUSES.ERROR;
                state.users = [];
                state.error = payload;
                toast.error(payload || 'Something went wrong!!!');
            })
    }
});


export const users =  userListSlice.reducer;